import {
  ApolloClient,
  createHttpLink,
  gql,
  InMemoryCache,
  NormalizedCacheObject,
  OperationVariables,
} from '@apollo/client/core';
import { FusionQueryProvider } from '@devxdiscover/devhub-common';

/**
 * A provider for querying the Fusion graph
 */
export class ApolloClientQueryProvider implements FusionQueryProvider {
  private client: ApolloClient<NormalizedCacheObject>;

  constructor(url: string) {
    const httpLink = createHttpLink({
      uri: url,
    });
    this.client = new ApolloClient({
      link: httpLink,
      cache: new InMemoryCache(),
    });
  }

  /**
   * Queries the Fusion API
   * @param query The query
   * @param variables The variables
   * @private
   */
  public async query<TResult>(
    query: string,
    variables: OperationVariables,
  ): Promise<{ data: TResult }> {
    return this.client.query({
      query: gql`
        ${query}
      `,
      variables,
    });
  }

  /**
   * Runs mutation on Federated Fusion graph
   * @param mutation - The mutation query
   * @param variables - The input variables
   */
  public async mutate<TResult>(
    mutation: string,
    variables: OperationVariables = {},
  ): Promise<{ data: TResult | null | undefined }> {
    const result = await this.client.mutate<TResult>({
      mutation: gql`
        ${mutation}
      `,
      variables,
    });
    return { data: result.data };
  }
}
